import React, {useState, useEffect} from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import API_BASE_URL from '../../../../Constants';

const MaintenanceRoutePlanning = () => {
    const [maintenanceData, setMaintenanceData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentRoute, setCurrentRoute] = useState('01');
    const [currentDescription, setCurrentDescription] = useState('Mid Town');
    const [showAllRoutes, setShowAllRoutes] = useState(false);


    const relatedValues = {
        "01": "Mid Town",
        "02": "Downtown",
        "03": "Uptown",
        "04": "Suburbs",
        "05": "Outskirts"
    };

    const totalDevices = filteredData.reduce((total) => total + 1, 0);

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(API_BASE_URL + '/api/maintenance/maintenancerouteplanning', {credentials: 'include'});
            const data = await response.json();
            setMaintenanceData(data);
        };
        fetchData();
    },[]);

    useEffect(() => {
        handleSearch();
    }, [maintenanceData]);

    const exportData = (data, filename) => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), filename);
    }


    const handlePrev = () => {
        const newValue = parseInt(currentRoute);
        if (newValue > 1) {
            const updatedValue = String(newValue - 1).padStart(2, '0');
            setCurrentRoute(updatedValue);
            setCurrentDescription(relatedValues[updatedValue]);
        }
    };

    const handleNext = () => {
        const newValue = parseInt(currentRoute);
        if (newValue < 5) {
            const updatedValue = String(newValue + 1).padStart(2, '0');
            setCurrentRoute(updatedValue);
            setCurrentDescription(relatedValues[updatedValue]);
        }
    };

    const handleSearch = () => {
        const searchResult = maintenanceData.filter((item) => item.route === currentRoute);
        setFilteredData(searchResult);
    };

    const handleAllRoutesChange = (e) => {
        setShowAllRoutes(e.target.checked);
        if (e.target.checked) {
            setFilteredData(maintenanceData); // Show all data if checked
        } else {
            handleSearch(); // Filter by current route if unchecked
        }
    };

    return (
        <div className="container mx-auto">
            <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold mb-4">Maintenance Route Planning</h1>
            <div className='flex mb-4'> 
                <div className="mr-4">
                    <label className="block mb-1 font-semibold">Route</label>
                    <input type="text" id="box1" value= {currentRoute} readOnly>
                    </input>
                </div>
                <div className="mr-4">
                    <label className="block mb-1 font-semibold">Description</label>
                    <input type="text" id="box2" value= {currentDescription} readOnly></input>
                    <button onClick={handlePrev} id="prevButton">⬅️&nbsp;</button>
                    <button onClick={handleNext} id="nextButton">➡️</button>
                    <button onClick={handleSearch} id="searchButton">&nbsp;&nbsp;Search</button>
                </div>
                <div className="mr-4">
                        <label className="block mb-1 font-semibold">All Routes</label>
                        <input
                            type="checkbox"
                            id="allRoutesCheckbox"
                            checked={showAllRoutes}
                            onChange={handleAllRoutesChange}
                        ></input>
                </div>
            </div>
            
            <label className="flex items-center">
                    <button
                        type="export"
                        className="py-2 px-4 mr-10 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        onClick = {() => exportData(filteredData, 'MaintenanceRoutePlanning.xlsx')}
                    >
                        Export Excel
                    </button>
            </label>
            </div>
            <table className="min-w-full border border-gray-300">
                <thead>
                    <tr className="bg-gray-100">
                        <th className="border px-4 py-2">Mechanic</th>
                        <th className="border px-4 py-2">Contact #</th>
                        <th className="border px-4 py-2">Site Address</th>
                        <th className="border px-4 py-2">Device ID</th>
                        <th className="border px-4 py-2">Device Description</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredData.map((data) => (
                        <tr key={data.id} className="border-t">
                            <td className="border px-4 py-2">{data.mechanic}</td>
                            <td className="border px-4 py-2">{data.contact}</td>
                            <td className="border px-4 py-2">{data.siteAddress}</td>
                            <td className="border px-4 py-2">{data.deviceId}</td>
                            <td className="border px-4 py-2">{data.deviceDescription}</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                    <td colSpan="3" className="border px-4 py-2 text-right font-semibold">Total Devices:</td>
                    <td className="border px-4 py-2">{totalDevices}</td>
                    </tr>
                </tfoot>
            </table>
            
        </div>
    );
}

export default MaintenanceRoutePlanning;
